var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "down-arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-2-1h20v20H-2z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#down-arrow_svg__a)",
    "data-name": "Scroll Group 5",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(2 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4,
    d: "M1.252 5.616a.68.68 0 0 1 .88-.068l.076.068 5.844 5.809 5.844-5.809a.68.68 0 0 1 .882-.065l.074.065a.671.671 0 0 1 .066.877l-.066.073-6.321 6.289a.68.68 0 0 1-.879.061l-.076-.065-6.324-6.285a.671.671 0 0 1 0-.95Z",
    "data-name": "Path 370"
  }))));
};
export default SvgDownArrow;